/**
 * Whether the Coins programme is switched on (vendure-app Global settings › Veroc Coins), for
 * entry points that must not offer it while it is off. False during SSR and until the browser
 * has read the programme. The switch is global, so the last answer is kept while a customer or
 * locale change reloads the programme instead of flickering the entries away.
 */
export function useRewardsEnabled() {
  const rewards = useRewards()
  const enabled = useState('rewards-enabled', () => false)
  watch(() => rewards.programme.value?.enabled, (value) => {
    if (value != null)
      enabled.value = value
  }, { immediate: true })
  onMounted(() => {
    void rewards.loadProgramme().catch(() => {})
  })
  watch(rewards.scope, () => {
    void rewards.loadProgramme().catch(() => {})
  })
  return readonly(enabled)
}
